module.exports = __webpack_public_path__ + "img/fm.67f27f62.svg";